module.exports = __webpack_public_path__ + "img/twitter.28566453.svg";